<template>
    <span v-if="uploadInfo.file_name" class="file">
        <span class="file-view">
            <v-icon :name="fileTypePdf ? 'file_icon_pdf_light' : 'file_icon_picture_light'" remote class="icon" size="18" />
            <span class="file-view-text">
                <span class="file-view-name">{{ uploadInfo.file_name }}</span>
                <span v-if="uploadInfo.size" class="file-view-size">({{ uploadInfo.size }})</span>
            </span>
            <span class="file-view-opt">
                <v-tip ref="viewDisabled" placement="top">该类型文件暂不支持预览</v-tip>
                <template v-if="isMainCorp">
                    <v-button v-if="fileTypePdf" v-tip:viewDisabled.hover type="text" icon="basic_password_on_line" disabled remote placement="top" />
                    <v-button v-else type="text" icon="basic_password_on_line" remote :disabled="!uploadInfo.image" @click.prevent="view" />
                </template>
                <v-button type="text" icon="basic_delete_line" remote @click.prevent="deleteItem" />
            </span>
            <v-image-viewer
                v-model="showPhotoPreView"
                :urls="photoUrls"
                :initial-index="photoPreviewIndex"
                close-on-click-mask
                @close="showPhotoPreView = false"
            />
        </span>
    </span>
</template>
<script>
export default {
    props: {
        uploadInfo: {
            type: Object,
            default: () => {},
        },
        isMainCorp: {
            type: Boolean,
            default: false,
        },
        attachmentInfo: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            showPhotoPreView: false,
            photoPreviewIndex: 0,
        };
    },
    computed: {
        fileTypePdf() {
            return this.uploadInfo.file_name?.endsWith('.pdf');
        },
        photoUrls() {
            const imgs = this.attachmentInfo?.filter(item => !item.file_name.endsWith('.pdf'));
            if (!imgs) return [];
            return imgs?.map(item => item.image);
        },
    },
    methods: {
        deleteItem() {
            this.$emit('delete');
        },
        view() {
            if (!this.uploadInfo.image) return;
            this.photoPreviewIndex = this.attachmentInfo.findIndex(item => item.image === this.uploadInfo.image);
            this.showPhotoPreView = true;
        },
    },
};
</script>

<style lang="less" scoped>
.file {
    display: inline-block;
    margin-top: var(--spacing-base);
}
.file-view {
    padding: 0 var(--spacing-tight);
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 0;
    box-sizing: border-box;
    border-radius: var(--radius-normal);
    border: 1px solid var(--color-border-normal);
    background: var(--color-bg-1);
    &-text {
        margin: 0 var(--spacing-tight);
        flex: 1;
        width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &-name {
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
        cursor: pointer;
    }

    &-size {
        color: var(--color-text-caption);
    }
}
</style>
